import React, { useEffect, useState, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import gsap from 'gsap';

// Fonts to cycle through for the animated logo
const logoFonts = [
    "'Playfair Display', serif", // Serif elegant
    "'Bebas Neue', sans-serif",  // Bold & condensed
    "'Caveat', cursive",         // Handwritten
    "'Amiri', serif",            // Arabic style
    "'Abril Fatface', cursive"   // Heavy display
];

// Texts to cycle through, matching the fonts
const logoTexts = [
    "NASS",
    "NASS",
    "NASS",
    "ايناس", // Arabic for Ines
    "NASS"
];

export default function Header() {
    const [scrolled, setScrolled] = useState(false);
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [fontIndex, setFontIndex] = useState(0);
    const location = useLocation();
    const headerRef = useRef(null);

    const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

    useEffect(() => {
        const handleScroll = () => {
            setScrolled(window.scrollY > 50);
        };
        window.addEventListener('scroll', handleScroll);

        // Logo animation interval
        const intervalId = setInterval(() => {
            setFontIndex((prev) => (prev + 1) % logoFonts.length);
        }, 200);

        return () => {
            window.removeEventListener('scroll', handleScroll);
            clearInterval(intervalId);
        };
    }, []);

    // Prevent scrolling when mobile menu is open
    useEffect(() => {
        if (isMenuOpen) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = '';
        }

        return () => {
            document.body.style.overflow = '';
        };
    }, [isMenuOpen]);

    const isActive = (path) => location.pathname === path ? 'active' : '';

    return (
        <header ref={headerRef} className={`header ${scrolled ? 'scrolled' : ''} ${isMenuOpen ? 'menu-open' : ''}`}>
            <div className="header__left">
                <ul className="header__nav">
                    <li><a href="/" className={isActive('/')}>Accueil</a></li>
                    <li><a href="/projets" className={isActive('/projets')}>Projets</a></li>
                </ul>
            </div>

            <div className="header__logo-wrap">
                <a href="/" className="header__logo-text" style={{
                    fontFamily: logoFonts[fontIndex],
                    fontSize: '2rem',
                    color: '#1a1a1a', /* Charcoal / dark */
                    textDecoration: 'none',
                    letterSpacing: '0.05em'
                }}>
                    {logoTexts[fontIndex]}
                </a>
            </div>

            <div className="header__right">
                <ul className="header__nav">
                    <li><a href="/a-propos" className={isActive('/a-propos')}>À propos</a></li>
                    <li><a href="/contact" className={isActive('/contact')}>Contact</a></li>
                </ul>
                <button className="header__menu-btn" aria-label="Menu" onClick={toggleMenu}>
                    <span></span>
                    <span></span>
                </button>
            </div>

            {/* Mobile overlay menu */}
            <div className={`mobile-nav ${isMenuOpen ? 'open' : ''}`}>
                <ul>
                    <li><a href="/" onClick={toggleMenu}>Accueil</a></li>
                    <li><a href="/projets" onClick={toggleMenu}>Projets</a></li>
                    <li><a href="/a-propos" onClick={toggleMenu}>À propos</a></li>
                    <li><a href="/contact" onClick={toggleMenu}>Contact</a></li>
                </ul>
            </div>
        </header>
    );
}
